import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, LogIn } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import './Modal.css';

const ArchitectsModal = ({ onClose }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleLoginClick = () => {
    onClose();
    navigate('/login');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label={t('common.close')}>
          <X size={24} />
        </button>

        <div className="modal-header">
          <h2>{t('arch.title')}</h2>
          <button
            className="partner-login-btn"
            onClick={handleLoginClick}
            aria-label={t('common.partnerLogin')}
          >
            <LogIn size={18} aria-hidden="true" />
            <span>{t('common.partnerLogin')}</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-image">
            <img
              src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800"
              alt="Architecture"
            />
          </div>

          <div className="modal-text">
            <h3>{t('arch.h3')}</h3>
            <p>{t('arch.p1')}</p>

            <h4>{t('arch.h4')}</h4>
            <ul>
              {t('arch.list').map((item, i) => <li key={i}>{item}</li>)}
            </ul>

            <p>{t('arch.p2')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchitectsModal;
